if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}

const syncTempdropPremiumTrialCopy = () => {
  const path = window.location.pathname.replace(/\/$/, '');
  if (!path.endsWith('/products/tempdrop-fertility-monitor')) return;

  const premiumCopy = '<p>The core app is completely free and gives you everything you need to track and understand your cycle. Every Tempdrop purchase also includes <strong>2 months of Tempdrop Premium free</strong>, so you can try the additional fertility insights, automatic interpretation and sleep features before deciding whether you want to continue with the optional subscription.</p>';

  document.querySelectorAll('.custom-image-text-app__premium-text').forEach((element) => {
    element.innerHTML = premiumCopy;
  });
};

syncTempdropPremiumTrialCopy();
document.addEventListener('DOMContentLoaded', syncTempdropPremiumTrialCopy, { once: true });
document.addEventListener('shopify:section:load', syncTempdropPremiumTrialCopy);
